import { z } from 'zod'

import { dateTimeFilterSchema, numberFilterSchema, stringFilterSchema, stringInFilterSchema } from './base_filters'

// TODO: steel系も一緒に扱うか微妙
export const millsheetsFilterSchema = z.object({
  manufacturerName: stringInFilterSchema.optional(),
  issuedDate: dateTimeFilterSchema.optional(),
  no: stringFilterSchema.optional(),
  steelTypes: stringFilterSchema.optional(),
  sectionTypes: stringFilterSchema.optional(),
  sizes: stringFilterSchema.optional(),
  totalWeight: numberFilterSchema.optional(),
  status: stringInFilterSchema.optional(),
  submissionDate: stringInFilterSchema.optional(),
  tradingCompany: stringFilterSchema.optional(),
  customer: stringFilterSchema.optional(),
  constructionArea: stringFilterSchema.optional(),
  member: stringFilterSchema.optional(),
  constructionName: stringFilterSchema.optional(),
  orderNumber: stringFilterSchema.optional(),
  innerNo: stringFilterSchema.optional(),
  steelHeatNumber: stringFilterSchema.optional(),
  steelIndividualNumber: stringFilterSchema.optional(),
  steelSteelType: stringInFilterSchema.optional(),
  steelSectionType: stringInFilterSchema.optional(),
  steelSize: stringFilterSchema.optional(),
  steelLength: stringFilterSchema.optional(),
  steelWeightAfterProcessing: stringFilterSchema.optional(),
  steelSteelQuantity: numberFilterSchema.optional(),
  steelWeight: numberFilterSchema.optional(),
})
export type MillsheetsFilter = z.infer<typeof millsheetsFilterSchema>

const sorterDirectionSchema = z.enum(['asc', 'desc'])
export const millsheetsSorterSchema = z.union([
  z.object({ manufacturerName: sorterDirectionSchema }),
  z.object({ issuedDate: sorterDirectionSchema }),
  z.object({ no: sorterDirectionSchema }),
  z.object({ steelTypes: sorterDirectionSchema }),
  z.object({ steelSectionTypes: sorterDirectionSchema }),
  z.object({ sectionTypes: sorterDirectionSchema }),
  z.object({ sizes: sorterDirectionSchema }),
  z.object({ totalWeight: sorterDirectionSchema }),
  z.object({ status: sorterDirectionSchema }),
  z.object({ orderNumber: sorterDirectionSchema }),
  z.object({ innerNo: sorterDirectionSchema }),
  z.object({ steelHeatNumber: sorterDirectionSchema }),
  z.object({ steelSteelType: sorterDirectionSchema }),
  z.object({ steelSize: sorterDirectionSchema }),
  z.object({ steelSteelQuantity: sorterDirectionSchema }),
  z.object({ steelWeight: sorterDirectionSchema }),
  z.object({ tradingCompany: sorterDirectionSchema }),
  z.object({ customer: sorterDirectionSchema }),
  z.object({ constructionArea: sorterDirectionSchema }),
  z.object({ member: sorterDirectionSchema }),
  z.object({ constructionName: sorterDirectionSchema }),
])
export type MillsheetsSorter = z.infer<typeof millsheetsSorterSchema>

export const millsheetSearchConditionSchema = z.object({
  filter: millsheetsFilterSchema.optional(),
  sorter: millsheetsSorterSchema.array().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
})
export type MillsheetSearchCondition = z.infer<typeof millsheetSearchConditionSchema>
